import React from 'react'
import { useDispatch } from 'react-redux'
import { Button, ButtonGroup, P, Wrapper } from '@farewill/ui'

import SimpleList from 'components/styled/simple-list'
import { hideModal } from 'state/actions'
import { MergeWarningData } from './config'

export const MergeContactsModal = ({
  config,
}: {
  config: {
    thisContact: { name: string }
    otherContact: MergeWarningData
    mergeContact: () => void
  }
}): React.ReactElement => {
  const dispatch = useDispatch()
  const { thisContact, otherContact, mergeContact } = config

  const priorityName = otherContact.hasPriority
    ? otherContact.name
    : thisContact.name
  const discardedName = otherContact.hasPriority
    ? thisContact.name
    : otherContact.name

  return (
    <Wrapper>
      <P>The contact name will be {priorityName}.</P>
      <SimpleList bullets>
        <li>
          Information you have entered for {discardedName} will be deleted.
        </li>
        <li>Any leads or products will be reassigned to {priorityName}.</li>
      </SimpleList>
      <ButtonGroup horizontal>
        <Button.BorderedDark onClick={() => dispatch(hideModal())}>
          Cancel
        </Button.BorderedDark>
        <Button.Danger onClick={mergeContact}>Confirm merge</Button.Danger>
      </ButtonGroup>
    </Wrapper>
  )
}
